import { render } from "./Departamentos.vue?vue&type=template&id=90d68494"
import script from "./Departamentos.vue?vue&type=script&lang=js"
export * from "./Departamentos.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__